import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { routes } from './routes';
import { MainLayout } from './components';
import { ProtectedPage } from './pages/protectedPage';
import { InactivityMonitor } from './components/inactivityMonitor/InactivityMonitor';

function App() {
    return (
        <Router>
            <InactivityMonitor />
            <MainLayout>
                <Switch>
                    {routes.map((route) => (
                        <ProtectedPage {...route} key={route.path} />
                    ))}
                </Switch>
            </MainLayout>
        </Router>
    );
}

export default App;
